export enum WOTypeID {
  Preventive = 'preventive',
  Project = 'project',
  Safety = 'safety',
}

export enum ScheduleTypes {
  NoSchedule = 1,
  Recurring = 2,
  FixedDates = 3,
  Gap = 4,
}

export enum AssetAllocationTypes {
  Assets = 1,
  AssetCategory = 2,
}

export enum AssetApprovalTypes {
  UseAssetSetting = 1,
  OverrideApproval = 2,
}

export enum PMDateTypes {
  Include = 1,
  Exclude = 2,
}

export enum ScheduleEndPattern {
  Never = 'Never',
  Occurrence = 'Occurrence',
  Date = 'Date',
}

export enum PMObjectStatuses {
  Disabled = 0,
  Active = 1,
}
